import { RegisterOptions } from 'react-hook-form';
import React from 'react';
import { InputText, InputTextProps } from '../input-text';
import { Utils } from '../../../utils';

type Props = InputTextProps & {
  registerOptions?: RegisterOptions;
};

type TypeLater = any;

export const InputTextNullable = React.forwardRef<TypeLater, Props>(
  (props, ref) => (
    <InputText
      {...props}
      // @ts-ignore
      ref={
        typeof ref === 'function'
          ? ref({
            setValueAs: Utils.normalizeString,
            ...props.registerOptions,
          })
          : ref
      }
    />
  ),
);
